module.exports = __webpack_public_path__ + "img/ms-icon-144x144.5eb9706a.png";